import { AuthenticationTokenRow } from 'app/types/database'
import { useDatabase } from '../composables/database'
import { Token_JWT } from '../types/components/data-rendering'

type AuthenticationModelReturn = {
  /**Writes JWT to device. */
  writeJWT: (token: Token_JWT) => Promise<void>
  /**Loads JWT from device */
  loadJWT: () => Promise<AuthenticationTokenRow | undefined>
  inactivateJWT: () => Promise<void>
  removeJWT: () => Promise<void>
}
export const AuthenticationModel = (): AuthenticationModelReturn => {
  const { query, run } = useDatabase()
  const writeJWT = async (token: Token_JWT) => {
    const sql = `
        INSERT OR REPLACE INTO authentication_token (id, token, staffing_users_id)
        VALUES (0, ?, ?);
    `

    await run(sql, [JSON.stringify(token), Number(token.staffing_users_id)])
      .catch((error) => console.log(`Error saving auth token: ${error}`))
      .then(async () => {
        //see json token debug
        // const data = await query('select * from authentication_token')
        // console.log(data)
      })
  }

  const loadJWT = async () => {
    const sql = `
        SELECT * FROM authentication_token;
    `
    return await query(sql)
      .then((token) => {
        console.log('token', token)
        if (token && token[0]) {
          const data = token[0]
          return data as AuthenticationTokenRow
        } else {
          return undefined
        }
      })
      .catch((error) => {
        console.log(`Error loading JWT: ${error}`)
        return undefined
      })
  }

  const removeJWT = async () => {
    const sql = `
        DELETE FROM authentication_token;
    `
    return await run(sql, []).catch((error) => console.log(`Error deleting tokens: ${error}`))
  }

  const inactivateJWT = async () => {
    const sql = `
        UPDATE authentication_token
        SET active = 0;
    `
    return await run(sql, []).catch((error) => console.log(`Error invalidating token: ${error}`))
  }
  return {
    writeJWT,
    loadJWT,
    removeJWT,
    inactivateJWT,
  }
}
